module.exports = __webpack_public_path__ + "d8639974aa77b5ab30bd7da8035cf554.pdf";